import { createStyles } from "antd-style";

export const useIconStyles = createStyles(({ css }) => ({
  icon: css``,
}));
